'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import SingleOpenTooltip from './SingleOpenTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ContentLockedPopover extends Component {
  langKey(suffix) {
    return `components.header.saveDisabledDrop.${suffix}.message`;
  }
  renderErrorMessage() {
    const {
      buttonType
    } = this.props;
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: this.langKey(buttonType)
    });
  }
  render() {
    const {
      placement
    } = this.props;
    return /*#__PURE__*/_jsx(SingleOpenTooltip, {
      placement: placement,
      title: this.renderErrorMessage(),
      children: this.props.children
    });
  }
}
ContentLockedPopover.propTypes = {
  children: PropTypes.node.isRequired,
  buttonType: PropTypes.oneOf(['save', 'publish']),
  placement: PropTypes.string.isRequired
};
ContentLockedPopover.defaultProps = {
  placement: 'bottom left'
};